import { IJobSpeciality, JobSearchWebCriteria } from '@/app/types/jobs';
import SortBySelect from '@/modules/JobListing/components/SortBySelect/SortBySelect';

import { Grid, Typography } from '@material-ui/core';

import styles from './ResultsHeader.module.scss';

type ResultsHeaderProps = {
  readonly jobSpecialitiesMapped: Record<string, IJobSpeciality>;
  readonly query: JobSearchWebCriteria;
  readonly total: number;
  readonly isNonSchedulerLocationSelected: boolean;
  readonly mobile: boolean;
  readonly radiusInKm: string;
  readonly onSortChange: (value: string) => void;
};

const getJobResultText = (query: JobSearchWebCriteria, total: number) => {
  const jobsText = `job${total !== 1 ? 's' : ''}`;
  if (query.grade && !query.speciality) {
    return `${total} ${query.grade} ${jobsText} found`;
  }
  if (query.grade && query.speciality) {
    return `${total} ${query.speciality} ${query.grade} ${jobsText} found`;
  }

  return `${total} ${jobsText} found`;
};

function ResultsHeader({
  jobSpecialitiesMapped,
  query,
  total,
  isNonSchedulerLocationSelected,
  mobile,
  radiusInKm,
  onSortChange,
}: ResultsHeaderProps) {
  return (
    <Grid className={styles.resultsHeader} container direction="row" justifyContent="space-between">
      {jobSpecialitiesMapped && query.speciality && jobSpecialitiesMapped[query.speciality] && (
        <Grid item xs={12} className={styles.specialtyMessageWrapper}>
          <Typography variant="body1">
            {jobSpecialitiesMapped[query.speciality].description}
          </Typography>
        </Grid>
      )}
      <Grid item xs={8} className={styles.resultMessageWrapper}>
        <h2 className={styles.totalHeader} data-testid="job-search-results-message">
          {getJobResultText(query, total)}
        </h2>
        {isNonSchedulerLocationSelected && (
          <p className={styles.radius} data-testid="job-search-results-radius-message">
            {!mobile
              ? `Within a ${radiusInKm} km radius of the selected location`
              : `Within ${radiusInKm} km radius`}
          </p>
        )}
      </Grid>
      <Grid item xs={4} className={styles.sortbyWrapper}>
        <SortBySelect value={query.sortBy ?? ''} onChange={onSortChange} />
      </Grid>
    </Grid>
  );
}

export default ResultsHeader;
